
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/edit",
      function () {
        return require("private-next-pages/profile/edit/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/edit"])
      });
    }
  